import React from 'react';
import Header from 'gatsby-theme-carbon/src/components/Header';

const CustomHeader = props => (
  <Header {...props}>
    SKO Technical Academy -&nbsp;<span>Integration</span>
  </Header>
);

export default CustomHeader;
